import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-17/task-01";
import config from "appConfig";

const task: Slide = {
  title: "What is the attenuation behind the wall at the marked position in each case?",
  description: "Connect with lines.",
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 1,
      colsSize: [1, 2],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/17/task/task-1.svg`,
                },
              },
            },
          },
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
